import { IChartConfig } from "../interfaces/IChartConfig";
import { ChartDisplayMode } from "../enums/ChartDisplayMode.list";
import { StockSeriesType } from "../components/achart/achart.annotation.tools";
import { HistoryItemPeriod } from "../interfaces/historyItem";
import { IIndicatorInstances } from "../components/achart/indicators";
import { Workspace } from "./workspace.data";
import { callNextAsync } from "../services/BaseService";
import { AChartComponent } from "../components/achart/achart.component";
import { ITemplate } from "../components/template-preview/template-preview.component";
import { Annotation } from './annotation';

export class ChartConfig implements IChartConfig {
    _SupportLinesColor: string | null = null;
    public get SupportLinesColor () {
        return this._SupportLinesColor;
    }
    public set SupportLinesColor ( v: string | null ) {
        this.workspace.setHasChanges( this._SupportLinesColor == v, () => {
            this._SupportLinesColor = v;
            this._hasChanges = true;
        } );
    }
    annotations: { [ key: string ]: Object[] } = {};
    annotationsPerSymbol: { [ key: string ]: SymbolAnnottations[] } = {};
    private _Symbol: string = "";
    public get Symbol (): string {
        return this._Symbol;
    }
    public set Symbol ( v: string ) {
        this.workspace.setHasChanges( this._Symbol == v, () => {
            this._Symbol = v;
            this._hasChanges = true;
        } );
    }

    public get DisplayMode (): ChartDisplayMode {
        return this.workspace.chartDisplayMode;
    }
    public set DisplayMode ( v: ChartDisplayMode ) {
        if ( this.workspace.chartDisplayMode != v ) {
            this.workspace.chartDisplayMode = v;
        }
    }

    private _WizardSerie: StockSeriesType = StockSeriesType.LINE;
    public get WizardSerie (): StockSeriesType {
        return this._WizardSerie;
    }
    public set WizardSerie ( v: StockSeriesType ) {
        this.workspace.setHasChanges( this._WizardSerie == v, () => {
            this._WizardSerie = v;
            this._hasChanges = true;
        } );
    }

    private _ChartingSerie: StockSeriesType = StockSeriesType.CANDLESTICK;
    public get ChartingSerie (): StockSeriesType {
        return this._ChartingSerie;
    }
    public set ChartingSerie ( v: StockSeriesType ) {
        this.workspace.setHasChanges( this._ChartingSerie == v, () => {
            this._ChartingSerie = v;
            this._hasChanges = true;
        } );
    }

    private _ChartButtonsVisible: boolean = true;
    public get ChartButtonsVisible (): boolean {
        return this._ChartButtonsVisible;
    }
    public set ChartButtonsVisible ( v: boolean ) {
        this.workspace.setHasChanges( this._ChartButtonsVisible == v, () => {
            this._ChartButtonsVisible = v;
            this._hasChanges = true;
            callNextAsync( this.workspace.chartButtonsVisibleService.subscriber, v );
        } );
    }

    private _ShowTooltip: boolean = true;
    public get ShowTooltip (): boolean {
        return this._ShowTooltip;
    }
    public set ShowTooltip ( v: boolean ) {
        this.workspace.setHasChanges( this._ShowTooltip == v, () => {
            this._ShowTooltip = v;
            this._hasChanges = true;
            callNextAsync( this.workspace.showChartTooltipService.subscriber, v );
        } );
    }

    private _Period: { [ key: string/*ChartDisplayMode*/ ]: HistoryItemPeriod } = { wizard: HistoryItemPeriod.Min1, charting: HistoryItemPeriod.Min1, signals: HistoryItemPeriod.Min1 };
    public get Period (): { [ key: string/*ChartDisplayMode*/ ]: HistoryItemPeriod } {
        return this._Period;
    }
    public set Period ( v: { [ key: string/*ChartDisplayMode*/ ]: HistoryItemPeriod } ) {
        this.workspace.setHasChanges( this._Period == v, () => {
            this._Period = v;
            this._hasChanges = true;
        } );
    }

    setPeriod = ( displayMode: ChartDisplayMode, period: HistoryItemPeriod ) => {
        this.workspace.setHasChanges( this.Period[ displayMode ] == period, () => {
            this.Period[ displayMode ] = period;
            this._hasChanges = true;
        } );
    }

    private _BackgroundColor: string = "";
    public get BackgroundColor (): string {
        return this._BackgroundColor;
    }
    public set BackgroundColor ( v: string ) {
        this.workspace.setHasChanges( this._BackgroundColor == v, () => {
            this._BackgroundColor = v;
            this._hasChanges = true;
        } );
    }

    private _FontColor: string = "";
    public get FontColor (): string {
        return this._FontColor;
    }
    public set FontColor ( v: string ) {
        this.workspace.setHasChanges( this._FontColor == v, () => {
            this._FontColor = v;
            this._hasChanges = true;
        } );
    }

    private _GridColor: string = "";
    public get GridColor (): string {
        return this._GridColor;
    }
    public set GridColor ( v: string ) {
        this.workspace.setHasChanges( this._GridColor == v, () => {
            this._GridColor = v;
            this._hasChanges = true;
        } );
    }

    private _MinorGridColor: string = "";
    public get MinorGridColor (): string {
        return this._MinorGridColor;
    }
    public set MinorGridColor ( v: string ) {
        this.workspace.setHasChanges( this._MinorGridColor == v, () => {
            this._MinorGridColor = v;
            this._hasChanges = true;
        } );
    }

    private _AxisColor: string = "";
    public get AxisColor (): string {
        return this._AxisColor;
    }
    public set AxisColor ( v: string ) {
        this.workspace.setHasChanges( this._AxisColor == v, () => {
            this._AxisColor = v;
            this._hasChanges = true;
        } );
    }

    private _LineSeriesColor: string = "";
    public get LineSeriesColor (): string {
        return this._LineSeriesColor;
    }
    public set LineSeriesColor ( v: string ) {
        this.workspace.setHasChanges( this._LineSeriesColor == v, () => {
            this._LineSeriesColor = v;
            this._hasChanges = true;
        } );
    }

    private _WizardLineSeriesColor: string = "";
    public get WizardLineSeriesColor (): string {
        return this._WizardLineSeriesColor;
    }
    public set WizardLineSeriesColor ( v: string ) {
        this.workspace.setHasChanges( this._WizardLineSeriesColor == v, () => {
            this._WizardLineSeriesColor = v;
            this._hasChanges = true;
        } );
    }

    private _WizardLineSeriesWidth: string = "";
    public get WizardLineSeriesWidth (): string {
        return this._WizardLineSeriesWidth;
    }
    public set WizardLineSeriesWidth ( value: string ) {
        this._WizardLineSeriesWidth = value;
        this._hasChanges = true;
    }

    private _CandleStickSerieFallingColor: string = "";
    public get CandleStickSerieFallingColor (): string {
        return this._CandleStickSerieFallingColor;
    }
    public set CandleStickSerieFallingColor ( v: string ) {
        this.workspace.setHasChanges( this._CandleStickSerieFallingColor == v, () => {
            this._CandleStickSerieFallingColor = v;
            this._hasChanges = true;
        } );
    }

    private _CandleStickSerieRisingColor: string = "";
    public get CandleStickSerieRisingColor (): string {
        return this._CandleStickSerieRisingColor;
    }
    public set CandleStickSerieRisingColor ( v: string ) {
        this.workspace.setHasChanges( this._CandleStickSerieRisingColor == v, () => {
            this._CandleStickSerieRisingColor = v;
            this._hasChanges = true;
        } );
    }

    private _CandleStickSerieBorderColor: string = "";
    public get CandleStickSerieBorderColor (): string {
        return this._CandleStickSerieBorderColor;
    }
    public set CandleStickSerieBorderColor ( v: string ) {
        this.workspace.setHasChanges( this._CandleStickSerieBorderColor == v, () => {
            this._CandleStickSerieBorderColor = v;
            this._hasChanges = true;
        } );
    }

    private _CrosshairColor: string = "";
    public get CrosshairColor (): string {
        return this._CrosshairColor;
    }
    public set CrosshairColor ( v: string ) {
        this.workspace.setHasChanges( this._CrosshairColor == v, () => {
            this._CrosshairColor = v;
            this._hasChanges = true;
        } );
    }

    private _wizardIndicatorInstances: IIndicatorInstances = {};
    public get wizardIndicatorInstances (): IIndicatorInstances {
        return this._wizardIndicatorInstances;
    }
    public set wizardIndicatorInstances ( v: IIndicatorInstances ) {
        //  this.Workspace.setHasChanges(true,()=>{
        this._wizardIndicatorInstances = v;
        //  });
    }

    private _chartIndicatorInstances: IIndicatorInstances = {};
    public get chartIndicatorInstances (): IIndicatorInstances {
        return this._chartIndicatorInstances;
    }
    public set chartIndicatorInstances ( v: IIndicatorInstances ) {
        //this.Workspace.setHasChanges(true,()=>{
        this._chartIndicatorInstances = v;
        // });
    }

    private _wizardshowResistanceLines: boolean = true;
    public get wizardshowResistanceLines (): boolean {
        return this._wizardshowResistanceLines;
    }
    public set wizardshowResistanceLines ( v: boolean ) {
        this.workspace.setHasChanges( this._wizardshowResistanceLines == v, () => {
            this._wizardshowResistanceLines = v;
            this._hasChanges = true;
        } );
    }

    private _chartingshowResistanceLines: boolean = true;
    public get chartingshowResistanceLines (): boolean {
        return this._chartingshowResistanceLines;
    }
    public set chartingshowResistanceLines ( v: boolean ) {
        this.workspace.setHasChanges( this._chartingshowResistanceLines == v, () => {
            this._chartingshowResistanceLines = v;
            this._hasChanges = true;
        } );
    }

    instance?: AChartComponent;

    private _hasChanges: boolean = false;
    getHasChanges () {
        return this._hasChanges;
    }
    setHasChanges ( v: boolean ) {
        return this._hasChanges = this._hasChanges || v;
    }
    resetHasChanges () {
        this._hasChanges = false;
    }

    constructor ( private workspace: Workspace, cfg?: IChartConfig ) {
        if ( cfg ) {
            this.fromCfg( cfg );
        }
    }

    toJson (): string {
        let cfg: IChartConfig = {
            AxisColor: this._AxisColor,
            DisplayMode: this.DisplayMode,
            WizardSerie: this.WizardSerie,
            ChartingSerie: this.ChartingSerie,
            ChartButtonsVisible: this.ChartButtonsVisible,
            ShowTooltip: this.ShowTooltip,
            Period: this.Period,
            BackgroundColor: this.BackgroundColor,
            FontColor: this.FontColor,
            GridColor: this.GridColor,
            MinorGridColor: this.MinorGridColor,
            LineSeriesColor: this.LineSeriesColor,
            WizardLineSeriesColor: this.WizardLineSeriesColor,
            WizardLineSeriesWidth: this.WizardLineSeriesWidth,
            CandleStickSerieBorderColor: this.CandleStickSerieBorderColor,
            CandleStickSerieFallingColor: this.CandleStickSerieFallingColor,
            CandleStickSerieRisingColor: this.CandleStickSerieRisingColor,
            chartIndicatorInstances: {},
            wizardIndicatorInstances: {},
            wizardshowResistanceLines: this.wizardshowResistanceLines,
            chartingshowResistanceLines: this.chartingshowResistanceLines,
            Symbol: this.Symbol,
            annotations: this.annotations,
            annotationsPerSymbol: this.annotationsPerSymbol,
            CrosshairColor: this.CrosshairColor,
            SupportLinesColor: this.SupportLinesColor
        };
        return JSON.stringify( cfg );
    }

    fromJson ( json: string ) {
        let cfg: IChartConfig = JSON.parse( json );
        console.log( 'from json' );
        this.fromCfg( cfg );
    }

    fromCfg ( cfg: IChartConfig ) {
        this._AxisColor = cfg.AxisColor || this._AxisColor;
        //this.DisplayMode = cfg.DisplayMode || this.DisplayMode;
        this._BackgroundColor = cfg.BackgroundColor || this._BackgroundColor;
        this._CandleStickSerieBorderColor = cfg.CandleStickSerieBorderColor || this._CandleStickSerieBorderColor;
        this._CandleStickSerieFallingColor = cfg.CandleStickSerieFallingColor || this._CandleStickSerieFallingColor;
        this._CandleStickSerieRisingColor = cfg.CandleStickSerieRisingColor || this._CandleStickSerieRisingColor;
        this._ChartingSerie = cfg.ChartingSerie || this.ChartingSerie;
        this._FontColor = cfg.FontColor || this._FontColor;
        this._GridColor = cfg.GridColor || this._GridColor;
        this._LineSeriesColor = cfg.LineSeriesColor || this._LineSeriesColor;

        this._MinorGridColor = cfg.MinorGridColor || this._MinorGridColor;
        if ( typeof cfg.Period == 'object' )
            this._Period = cfg.Period || this._Period;
        this._Symbol = cfg.Symbol || this._Symbol;
        this._WizardLineSeriesColor = cfg.WizardLineSeriesColor || this.WizardLineSeriesColor;
        this._WizardLineSeriesWidth = cfg.WizardLineSeriesWidth || this.WizardLineSeriesWidth;

        this._WizardSerie = cfg.WizardSerie || this._WizardSerie;
        this._CrosshairColor = cfg.CrosshairColor || this._CrosshairColor;

        this.ChartButtonsVisible = false;// cfg.ChartButtonsVisible != undefined ? cfg.ChartButtonsVisible : true;
        this._ShowTooltip = cfg.ShowTooltip != undefined ? cfg.ShowTooltip : false;

        if ( cfg.chartingshowResistanceLines != undefined ) {
            this._chartingshowResistanceLines = cfg.chartingshowResistanceLines;
        }
        if ( cfg.wizardshowResistanceLines != undefined ) {
            this._wizardshowResistanceLines = cfg.wizardshowResistanceLines;
        }

        this._SupportLinesColor = cfg.SupportLinesColor || this._SupportLinesColor;
        this.annotations = cfg.annotations;

        if(cfg.annotationsPerSymbol)
        this.annotationsPerSymbol = cfg.annotationsPerSymbol;
        
        this.resetHasChanges();
    }
}

export interface SymbolAnnottations
{
    symbol:string;
    annotations:Object[];
}